if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        // this.cartNotification = document.querySelector('cart-notification');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        // this.cartNotification.setActiveElement(document.activeElement);

        // At submit time, derive the correct variant ID directly from the native
        // select values + embedded JSON — no dependency on stored currentVariant state.
        const variantEl = document.querySelector('variant-selects, variant-radios');
        const idInput = this.form.querySelector('input[name="id"]');
        console.log('[product-form v5] submit — idInput before fix:', idInput?.value, '| variantEl found:', !!variantEl);
        if (variantEl) {
          const selectedOptions = Array.from(
            variantEl.querySelectorAll('select'),
            (s) => s.value
          );
          let matchedVariant = null;
          try {
            const variantData = JSON.parse(
              variantEl.querySelector('[type="application/json"]').textContent
            );
            matchedVariant = variantData.find((v) =>
              !v.options.map((opt, i) => opt === selectedOptions[i]).includes(false)
            );
          } catch (e) { console.error('[product-form v5] JSON parse error:', e); }
          console.log('[product-form v5] selectedOptions:', selectedOptions, '| matched variant:', matchedVariant?.id, matchedVariant?.title, '| available:', matchedVariant?.available);
          if (matchedVariant) {
            if (!matchedVariant.available) {
              this.handleErrorMessage('Sorry, this product is currently sold out.');
              return;
            }
            if (idInput) idInput.value = matchedVariant.id;
          }
        }

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        // formData.append('items[1]id', 42812633350359);
        // formData.append('items[1]quantity', 1)
        // formData.append('properties[Accessories]', 'Catalytic Converter')
        // formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response);
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            // crossOriginIsolated.log(response)
            // this.cartNotification.renderContents(response);
          })

          .then(() => { })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");

            let sidecart = document.querySelector("side-cart");
            sidecart?.renderCart();
            sidecart?.openCart();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
